import * as HTTP_REQUEST from "./api";
import { handleResponse } from "../utils/functions";

const MODEL_PATH = "/aux";

export const getAllImportacion = async () => {
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}/importacion`);
  return handleResponse(response);
};

export const isAsistenciaEnabled = async () => {
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}/asistencia-enabled`);
  return handleResponse(response);
};

export const isPorSedeEnabled = async () => {
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}/por-sede-enabled`);
  return handleResponse(response);
};

export const isPorPeriodoEnabled = async () => {
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}/por-periodo-enabled`);
  return handleResponse(response);
};

export const getAllSedes = async () => {
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}/sedes`);
  return handleResponse(response);
};

export const getAllPeriodos = async () => {
  const response = await HTTP_REQUEST.get(`${MODEL_PATH}/periodos`);
  return handleResponse(response);
};
